import React from 'react';
import { colors, styles, typography } from '../theme';

// One archetype card in the Archetype Gallery (Tier 2 path).
// P1: Templates First. The card is the primary onboarding surface — every
// detail it shows is meant to reduce decision paralysis, not amplify it.
// P15: RPG Tradition — the "Plays like" subtitle anchors the archetype to a
// character players already know.

const ArchetypeCard = ({ archetype, onInspect, onSelect }) => {
  const [hover, setHover] = React.useState(false);
  const featuresPreview = (archetype.featurePreviews || []).slice(0, 2);

  return (
    <article
      data-testid={`archetype-card-${archetype.id}`}
      data-archetype-id={archetype.id}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => setHover(true)}
      onBlur={() => setHover(false)}
      style={{
        ...styles.card,
        ...(hover ? styles.cardHover : {}),
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
      }}
    >
      {/* Portrait placeholder */}
      <div
        style={{
          width: '100%',
          aspectRatio: '4 / 3',
          background: colors.bgInput,
          borderRadius: 6,
          border: `1px solid ${colors.borderLight}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 12,
          color: colors.textMuted,
          fontFamily: typography.headingFamily,
          fontSize: 32,
        }}
        aria-label={`${archetype.name} portrait placeholder`}
      >
        {archetype.name.slice(0, 1).toUpperCase()}
      </div>

      {/* Identity */}
      <h3
        style={{
          ...styles.heading,
          fontSize: 18,
          marginBottom: 4,
        }}
      >
        {archetype.name}
      </h3>
      {archetype.playsLike ? (
        <div
          style={{
            fontSize: 12,
            color: colors.textSecondary,
            fontStyle: 'italic',
            marginBottom: 8,
          }}
        >
          Plays like: {archetype.playsLike}
        </div>
      ) : null}

      <p
        style={{
          color: colors.textPrimary,
          margin: '0 0 12px 0',
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        {archetype.tagline}
      </p>

      {/* Two-feature foreshadow */}
      {featuresPreview.length ? (
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: '0 0 16px 0',
            fontSize: 12,
            color: colors.textSecondary,
            flexGrow: 1,
          }}
          data-testid={`features-preview-${archetype.id}`}
        >
          {featuresPreview.map((f) => (
            <li key={`${f.level}-${f.name}`} style={{ marginBottom: 4 }}>
              <span style={{ color: colors.accentLight, marginRight: 4 }}>•</span>
              {f.name}
              <span style={{ color: colors.textMuted, marginLeft: 4 }}>(L{f.level})</span>
            </li>
          ))}
        </ul>
      ) : null}

      {/* Actions */}
      <div style={{ display: 'flex', gap: 8, marginTop: 'auto' }}>
        <button
          type="button"
          onClick={() => onInspect?.(archetype.id)}
          data-testid={`inspect-${archetype.id}`}
          style={{ ...styles.buttonSecondary, flex: 1 }}
        >
          Inspect
        </button>
        <button
          type="button"
          onClick={() => onSelect?.(archetype.id)}
          data-testid={`select-${archetype.id}`}
          style={{ ...styles.buttonPrimary, flex: 1 }}
        >
          Select
        </button>
      </div>
    </article>
  );
};

export default ArchetypeCard;
